export const TENANT_SROVNEJSITO = 'srovnejsito.eu';
